angular.module('impactx.input').controller('ClassificationInputCtrl', [
    '$scope',
    ClassificationInputCtrl
]);

function ClassificationInputCtrl($scope) {
    var ctrl = this;

    $scope.$watch(function () {
        if (ctrl.data && ctrl.data.freeSelection) {
            return ctrl.data.freeSelection.value;
        }
    }, function (newVal, oldVal) {
        if (ctrl.onValueChange) {
            ctrl.onValueChange();
        }
    });
}